import React from 'react';
import { observer } from 'mobx-react';
import { samplingDistributions } from 'mobx-store';
import { SAMPLING_DISTRIBUTIONS_FORM } from 'store/form';

import CIFieldsComponent from 'components/CIFields';

const CIFieldsContainer = observer(
  class CIFieldsContainer extends React.Component {
    render () {
      return (
        <CIFieldsComponent
          form={SAMPLING_DISTRIBUTIONS_FORM}
          mean={samplingDistributions.dotsMean}
          stdev={samplingDistributions.dotsStdev}
        />
      );
    }
  }
);

export default CIFieldsContainer;
